/* ==========================================================================
   Boot

   Load order matters: markets and products are data, localization needs them
   to render prices, and the cart needs localization to price its lines.
   Each page sets STORE.assetBase before this runs so JS-built markup can
   resolve asset paths from whatever depth the page sits at.
   ========================================================================== */

(function () {
  'use strict';

  var EXIT_DURATION = 180; // keep in sync with the transition timing in base.css

  function start() {
    STORE.assetBase = STORE.assetBase || '';
    STORE.localization.init();
    STORE.cart.init();
    if (STORE.bundle) STORE.bundle.init();
    STORE.ui.init();
    if (STORE.reviewList) STORE.reviewList.init();
    initPageTransitions();
  }

  // Pages are plain static HTML, so every internal link is a full
  // navigation. Fade/slide the current page out before following it so the
  // change reads as a transition rather than an instant swap; the incoming
  // page fades in via the `store-loading` class already sitting on <html>.
  function initPageTransitions() {
    document.documentElement.classList.remove('store-loading');

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var link = e.target.closest && e.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (err) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      // Same-page anchors and hash links shouldn't trigger a full transition.
      if (url.pathname === window.location.pathname && url.hash) return;

      e.preventDefault();
      document.body.classList.add('store-leaving');
      window.setTimeout(function () {
        window.location.href = link.href;
      }, EXIT_DURATION);
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        document.body.classList.remove('store-leaving');
        document.documentElement.classList.remove('store-loading');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
